/**
 * @generated SignedSource<<3336fda424e2a7d585658731202b387c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
export type ProjectV2SingleSelectFieldOptionColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type MultiSelectFieldOptionFragment$data = {
  readonly color: ProjectV2SingleSelectFieldOptionColor;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "MultiSelectFieldOptionFragment";
};
export type MultiSelectFieldOptionFragment$key = {
  readonly " $data"?: MultiSelectFieldOptionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MultiSelectFieldOptionFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "MultiSelectFieldOptionFragment"
};

(node as any).hash = "6591f9d10f83629130e8f39595abde36";

export default node;
